




















































































































































import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import Multiselect from "vue-multiselect";
import get from "lodash-es/get";
import debounce from "lodash-es/debounce";
import isEmpty from "lodash-es/isEmpty";
import find from "lodash-es/find";
import map from "lodash-es/map";
import orderBy from "lodash-es/orderBy";
import groupBy from "lodash-es/groupBy";
import moment from "moment";
import DateRangePicker from "../../components/DateRangePicker.vue";
// import TestOrderData from "./TestOrderData";
import { EventBus } from "../../lib/EventBus";
// const testData = TestOrderData;

import {
  AutobedrijfViewModel,
  DropdownItemStringViewModel,
  DropdownItemModel,
  FixedPeriodType,
  FilterValuesPeriod,
} from "../../TypeScriptModels";

interface PivotOrderSettingsViewModel {
  CustomStartDate: string | null;
  CustomEndDate: string | null;
  ComparePeriodData: boolean | null;
  CustomStartDateCompare: string | null;
  CustomEndDateCompare: string | null;
  SelectedPeriod: FixedPeriodType;
  SelectedAutobedrijven: string[];
  SelectedVestigingen: string[];
  SelectedModellen: string[];
  SelectedModeljaren: number[];
  SelectedZones: number[];
}

interface PivotOrderOptionViewModel {
  Perioden: DropdownItemModel[];
  Zones: DropdownItemModel[];
  Autobedrijven: AutobedrijfViewModel[];
  Vestigingen: DropdownItemStringViewModel[];
  Modellen: DropdownItemStringViewModel[];
  Modeljaren: DropdownItemStringViewModel[];
}

export interface FilterPivotOrderValues {
  period: FilterValuesPeriod | null;
  zonesValue: any[];
  autobedrijvenValue: any[];
  vestigingenValue: any[];
  modellenValue: any[];
  modeljarenValue: any[];
  merkenValue: any[];
  periodFromDate: Date;
  periodToDate: Date;
  customFromDate: Date;
  customToDate: Date;
  comparePeriodData: boolean;
  customFromDateCompare: Date;
  customToDateCompare: Date;
}

export default Vue.extend({
  props: {
    selectedOptions: {
      required: true,
      type: Object as () => FilterPivotOrderValues,
      default: {
        period: {} as null | any,
        zonesValue: [] as any[],
        autobedrijvenValue: [] as any[],
        vestigingenValue: [] as any[],
        modellenValue: [] as any[],
        merkenValue: [] as any[],
        modeljarenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
        comparePeriodData: false as boolean,
        customFromDateCompare: new Date(),
        customToDateCompare: new Date(),
      } as FilterPivotOrderValues,
    },
  },

  data() {
    return {
      initialised: false,
      options: {
        Perioden: [] as DropdownItemModel[],
        Zones: [] as DropdownItemModel[],
        Autobedrijven: [] as AutobedrijfViewModel[],
        Vestigingen: [] as DropdownItemStringViewModel[],
        Modellen: [] as DropdownItemStringViewModel[],
        Modeljaren: [] as DropdownItemStringViewModel[],
      } as PivotOrderOptionViewModel,
      handlePreferenceChangedDebounced: null as null | Function,
      autobedrijvenOptionsUpdate: 0,
      vestigingenOptionsUpdate: 0,
    };
  },

  mounted() {
    this.handlePreferenceChangedDebounced = debounce(() => {
      this.reduceSelectedOptions();
      this.persistPreferences();
      this.$emit("preferences-changed", true);
    }, 300);
  },

  computed: {
    zonesOptions(): null | any[] {
      return orderBy(get(this.options, "Zones", []), ["Omschrijving"], ["asc"]);
    },

    zoneGebruiker(): boolean {
      return this.$store.getters.zoneUser;
    },

    autobedrijvenOptions(): any[] {
      let update = this.autobedrijvenOptionsUpdate;
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );
      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      return orderBy(autobedrijven, ["Omschrijving"], ["asc"]);
    },

    vestigingenOptions(): null | any[] {
      let update = this.vestigingenOptionsUpdate;
      let vestigingen = get(this.options, "Vestigingen", []);
      let autobedrijven = this.selectedOptions.autobedrijvenValue;

      if (isEmpty(autobedrijven)) autobedrijven = this.autobedrijvenOptions;

      if (!isEmpty(autobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          autobedrijven.some((ab: any) => String(ab.Id) === String(v.GroupId))
        );
      }

      return orderBy(vestigingen, ["Omschrijving"], ["asc"]);
    },

    modellenOptions(): null | any[] {
      return orderBy(
        get(this.options, "Modellen", []),
        ["Omschrijving"],
        ["asc"]
      );
    },

    modeljarenOptions(): null | DropdownItemStringViewModel[] {
      let modellen = this.selectedOptions.modellenValue;

      let modeljaren = get(
        this.options,
        "Modeljaren",
        []
      ) as DropdownItemStringViewModel[];

      // filter modeljaren die voor dit model bekend zijn
      if (!isEmpty(modeljaren) && !isEmpty(modellen)) {
        modeljaren = modeljaren.filter((a) =>
          modellen.some((model: any) => String(model.Id) === String(a.GroupId))
        );
      }

      let onbekendItem = find(modeljaren, (modeljaar) => modeljaar.Id === "0");
      if (!!onbekendItem) {
        onbekendItem.Omschrijving = this.$i18n.t("unknown").toString();
      }

      let filteredModelJaren = !!onbekendItem
        ? [onbekendItem]
        : ([] as DropdownItemStringViewModel[]);

      let overigeItems = modeljaren.filter((modeljaar) => modeljaar.Id !== "0");
      overigeItems = orderBy(
        map(groupBy(overigeItems, "Id"), (modelJarenGroep) => {
          return modelJarenGroep[0];
        }),
        ["Omschrijving"],
        ["asc"]
      );

      return [...filteredModelJaren, ...overigeItems];
    },

    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },

    makeOptions(): DropdownItemStringViewModel[] {
      if (this.multipleMakes) {
        return (this.$store.getters.importeurMerken as string[]).map((merk) => {
          return { Id: merk, Omschrijving: merk };
        });
      }
      return [];
    },
  },

  methods: {
    getSavedPreferences() {
      axios
        .get("/api/backend/v1/identity/preferences/orders/pivot")
        .then((response) => {
          if (!!response && !!response.data && !!response.data.FilterSettings) {
            const filtersettings = response.data
              .FilterSettings as PivotOrderSettingsViewModel;

            this.setFilterSettings(filtersettings);
          }

          this.initialised = true;
          this.$emit("initialised", true);
        })
        .catch((error) => {});
    },

    handlePreferencesChanged: function() {
      if (!!this.handlePreferenceChangedDebounced) {
        this.handlePreferenceChangedDebounced();
      }
    },

    handleDateoptionsChanged(perioden: { Id: number; Omschrijving: string }[]) {
      this.options.Perioden = perioden;
    },

    onDateRangePickerMounted(perioden: { Id: number; Omschrijving: string }[]) {
      this.handleDateoptionsChanged(perioden);
      this.fillFilters();
    },

    fillFilters() {
      axios
        .get("/api/backend/v1/dashboard/orders/grid/options")
        .then((response) => {
          if (!!response && !!response.data) {
            let {
              Vestigingen,
              Modellen,
              Zones,
              Autobedrijven,
              Modeljaren,
            } = response.data;

            this.options.Vestigingen = Vestigingen;
            this.options.Modellen = Modellen;
            this.options.Zones = Zones;
            this.options.Autobedrijven = Autobedrijven;
            this.options.Modeljaren = Modeljaren;
            this.getSavedPreferences();
          }
        })
        .catch((error) => {});
    },

    reduceSelectedOptions(): void {
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );
      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      if (!isEmpty(zones)) {
        let previous = isEmpty(this.selectedOptions.autobedrijvenValue)
          ? 0
          : this.selectedOptions.autobedrijvenValue.length;

        // verwijder geselecteerde autobedrijven als die buiten het huidige zone filter vallen
        this.selectedOptions.autobedrijvenValue = this.selectedOptions.autobedrijvenValue.filter(
          (aValue: any) =>
            zones.some((zone: any) => String(zone.Id) === String(aValue.ZoneId))
        );
        let current = isEmpty(this.selectedOptions.autobedrijvenValue)
          ? 0
          : this.selectedOptions.autobedrijvenValue.length;

        if (current != previous) this.autobedrijvenOptionsUpdate++;
      }

      //////////////////////////////////////////////
      let vestigingen = get(this.options, "Vestigingen", []);
      let autobedrijvenOptionsCurrent = autobedrijven;
      
      autobedrijven = this.selectedOptions.autobedrijvenValue;

      if (isEmpty(autobedrijven)) autobedrijven = autobedrijvenOptionsCurrent;

      if (!isEmpty(autobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          autobedrijven.some((ab: any) => String(ab.Id) === String(v.GroupId))
        );
      }

      let previous = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      // update selected vestigingen als die buiten het huidige filter vallen
      this.selectedOptions.vestigingenValue = this.selectedOptions.vestigingenValue.filter(
        (vValue: any) =>
          vestigingen.some((v: any) => String(v.Id) === String(vValue.Id))
      );

      let current = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      if (current != previous) this.vestigingenOptionsUpdate++;
    },

    persistPreferences() {
      if (!this.initialised) return;

      let settings = this.getPreferences();

      axios
        .post("/api/backend/v1/identity/preferences/orders/pivot", settings, {
          headers: { "Content-Type": "application/json" },
        })
        .catch((error) => {
          EventBus.$emit("add-toastr", {
            text: this.$t("filtersaveerror").toString(),
            type: "error",
          });
        });
    },

    getPreferences(): PivotOrderSettingsViewModel {
      const isCompareDataPeriod = this.selectedOptions.comparePeriodData;

      return {
        CustomStartDate: (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString(),
        CustomEndDate: (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString(),
        ComparePeriodData: this.selectedOptions.comparePeriodData,
        CustomStartDateCompare: isCompareDataPeriod
          ? (moment(this.selectedOptions.customFromDateCompare)).local().startOf("day").toDate().toISOString()
          : null,
        CustomEndDateCompare: isCompareDataPeriod
          ? (moment(this.selectedOptions.customToDateCompare)).local().endOf("day").toDate().toISOString()
          : null,
        SelectedPeriod: get(
          this.selectedOptions,
          "period.Id",
          FixedPeriodType.ThisYear
        ),
        SelectedAutobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedVestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedZones: get(
          this.selectedOptions as Object,
          "zonesValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        SelectedModellen: get(
          this.selectedOptions as Object,
          "modellenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedModeljaren: get(
          this.selectedOptions as Object,
          "modeljarenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
      } as PivotOrderSettingsViewModel;
    },

    setPreferences(filterSettings: string): void {
      let filter = JSON.parse(filterSettings) as PivotOrderSettingsViewModel;

      this.setFilterSettings(filter);

      this.handlePreferencesChanged();
    },

    setFilterSettings(filterSettings: PivotOrderSettingsViewModel): void {
      if (!!filterSettings && !!filterSettings.SelectedZones) {
        this.selectedOptions.autobedrijvenValue = (get(
          this.options,
          "Autobedrijven",
          []
        ) as any[]).filter(
          (mj) => filterSettings.SelectedAutobedrijven.indexOf(mj.Id) > -1
        );

        this.selectedOptions.vestigingenValue = (get(
          this.options,
          "Vestigingen",
          []
        ) as any[]).filter(
          (a) => filterSettings.SelectedVestigingen.indexOf(a.Id) > -1
        );

        this.selectedOptions.zonesValue = (get(
          this.options,
          "Zones",
          []
        ) as any[]).filter(
          (v) => filterSettings.SelectedZones.indexOf(v.Id) > -1
        );

        this.selectedOptions.modellenValue = (get(
          this.options,
          "Modellen",
          []
        ) as any[]).filter(
          (a) => filterSettings.SelectedModellen.indexOf(a.Id) > -1
        );

        let modeljaren = (get(this.options, "Modeljaren", []) as any[]).filter(
          (mj) => filterSettings.SelectedModeljaren.indexOf(mj.Id) > -1
        );

        // Alleen unieke (distinct) waarden tonen
        this.selectedOptions.modeljarenValue = map(
          groupBy(modeljaren, "Id"),
          (modelJarenGroep) => {
            return modelJarenGroep[0];
          }
        );

        let period = find(
          get(this.options, "Perioden", []),
          (p) => p.Id === filterSettings.SelectedPeriod
        );

        if (!!period) {
          this.selectedOptions.period = period;
        }

        this.selectedOptions.customFromDate = moment(
          filterSettings.CustomStartDate as string
        ).local().startOf("day").toDate();

        this.selectedOptions.customToDate = moment(
          filterSettings.CustomEndDate as string
        ).local().endOf("day").toDate();

        this.selectedOptions.comparePeriodData = !!filterSettings.ComparePeriodData;

        this.selectedOptions.customFromDateCompare = moment(
          filterSettings.CustomStartDateCompare as string
        ).local().startOf("day").toDate();

        this.selectedOptions.customToDateCompare = moment(
          filterSettings.CustomEndDateCompare as string
        ).local().endOf("day").toDate();
      }
    },
  },

  components: {
    Multiselect,
    DateRangePicker,
  },
});
